import {KTCard, KTCardBody, QUERIES} from '../../../../../_metronic/helpers'
import {CForm} from '../../../../../_component/Form'
import {fields} from './core/_models'
import {useQuery} from '@tanstack/react-query'
import {v2_get_request_api} from '../../../../../api/get'
import {createPaymentSetting, updatePaymentSetting} from './core/_requests'

const List = () => {
  const {
    isInitialLoading: isLoading,
    data,
    refetch,
  } = useQuery({
    queryKey: [QUERIES.PAYMENT_SETTINGS_LIST],
    queryFn: v2_get_request_api,
  })
  return (
    <>
      <KTCard>
        <KTCardBody>
          <CForm
            isLoading={isLoading}
            data={data}
            create={createPaymentSetting}
            update={updatePaymentSetting}
            fields={fields}
            id={data?.id}
            model={QUERIES.PAYMENT_SETTINGS_LIST}
            refetch={refetch}
            doNotResetOnSuccess={true}
          />
        </KTCardBody>
      </KTCard>
    </>
  )
}

export const PaymentSettingsListWrapper = () => <List />
